module.exports = __webpack_public_path__ + "img/bottom_qr_code@2x.7a0a01c4.png";